import {useEffect, useState} from 'react';
import {Outlet} from 'react-router-dom';
import StorageUtils from '@livongo/utilities/system/storage';
import ImpersonationHeader from '../Header/ImpersonationHeader';
import ImpersonationFooter from '../Footer/ImpersonationFooter';
import MixpanelUtils from '../common/mix-panel';

const Layout = () => {
    const [impersonationInfo, setImpersonationInfo] = useState(null);
    const [loggedInMemberId, setLoggedInMemberId] = useState(null);

    useEffect(() => {
        const cookie = StorageUtils.get({
            key: 'impersonation',
            type: 'cookie',
            useNative: true,
            parse: true,
        });

        if (cookie) {
            const transformedInfo = {
                impersonatedName: cookie.impersonated_name,
                impersonatorTypeId: cookie.impersonator_type_id,
                impersonatorType: cookie.impersonator_type,
                impersonatedType: cookie.impersonated_type,
            };

            setImpersonationInfo(transformedInfo);
            setLoggedInMemberId(cookie.impersonated_type_id);

            MixpanelUtils.setSuperProps({
                impersonation: true,
            });
        }
    }, []);

    const isImpersonating = Boolean(impersonationInfo);

    return (
        <>
            {isImpersonating && (
                <ImpersonationHeader impersonationInfo={impersonationInfo} />
            )}
            <main>
                <Outlet />
            </main>
            {isImpersonating && (
                <ImpersonationFooter
                    impersonationInfo={impersonationInfo}
                    loggedInMemberId={loggedInMemberId}
                />
            )}
        </>
    );
};

export default Layout;
